import { getByteLen } from '@/common/js/utils'
import { BRAND_ENUM, MINIGAME_CONVERSION_TARGET_LIST, APP_CONVERSION_TARGET_LIST } from './creative-const'
import { SITE_ENUM } from './siteset/siteset-const.js'
import { PLATFORM } from '@/views/create/gdt/model/project-const.js'

export function customValidator(prop) {
  if (prop.name === 'video_options') {
    return [{ validator: videoOptionsValidator.bind(prop), trigger: 'blur', required: prop.required }]
  }

  if (prop.name === 'image_options') {
    return [{ validator: imageOptionsValidator.bind(prop), trigger: 'blur', required: prop.required }]
  }

  if (prop.parent_name === 'element_story') {
    if (prop.name === 'image') {
      return [{ validator: elementStoryValidator.bind(prop), trigger: 'blur', required: prop.required }]
    }
  }

  if (prop.name === 'title_options') {
    return [{ validator: titleOptionsValidator.bind(prop), trigger: 'blur', required: prop.required }]
  }

  if (prop.parent_name === 'brand') {
    if (prop.name === 'brand_img') {
      return [{ validator: brandImageValidator.bind(prop), trigger: 'blur', required: prop.required }]
    }

    if (prop.name === 'brand_name') {
      return [{ validator: brandNameValidator.bind(prop), trigger: 'blur', required: prop.required }]
    }
  }

  if (prop.parent_name === '' && prop.name === 'button_text') {
    return [{ validator: buttonTextValidator.bind(prop), trigger: 'change', required: prop.required }]
  }

  if (prop.name === 'description_options') {
    return [{ validator: descriptionOptionsValidator.bind(prop), trigger: 'blur', required: prop.required }]
  }

  if (prop.name === 'end_page_type') {
    return [{ validator: endPageTypeValidator.bind(prop), trigger: 'change', required: prop.required }]
  }

  if (prop.name === 'end_page_desc') {
    return [{ validator: endPageDescValidator.bind(prop), trigger: 'blur', required: prop.required }]
  }

  if ((prop.parent_name === 'wechat_channels_spec' && prop.name) === 'username') {
    return [{ validator: wechatChannelValidator.bind(prop), trigger: 'change', required: prop.required }]
  }

  if (prop.parent_name === 'floating_zone_struct') {
    if (prop.name === 'type') {
      return [{ validator: floatingZoneType.bind(prop), trigger: 'change', required: prop.required }]
    }

    if (prop.name === 'image_id') {
      return [{ validator: floatingZoneImage.bind(prop), trigger: 'blur', required: prop.required }]
    }

    if (prop.name === 'desc') {
      return [{ validator: floatingZoneDesc.bind(prop), trigger: 'blur', required: prop.required }]
    }

    if (prop.name === 'name') {
      return [{ validator: floatingZoneName.bind(prop), trigger: 'blur', required: prop.required }]
    }

    if (prop.name === 'button_text') {
      return [{ validator: floatingZoneButtonText.bind(prop), trigger: 'change', required: prop.required }]
    }
  }
}

export const creativeFormRules = {
  groupName: [
    {
      required: true,
      message: '请输入创意组名称',
      trigger: 'blur'
    }
  ],
  name: [
    {
      required: true,
      message: '请输入创意名称',
      trigger: 'blur'
    },
    {
      min: 1,
      max: 100,
      message: '长度在1到100个字',
      trigger: 'blur'
    }
  ]
}

function valueLength(text) {
  // 两个字母占一个字符
  return Math.ceil(getByteLen(text) / 2)
}

/**
 * @description: 品牌图片校验
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 * @return {*}
 */
function brandImageValidator(rule, value, callback) {
  const { restriction } = this
  const { image_restriction } = restriction

  const model = value

  if (!model.brand_img) {
    return callback(new Error('请选择图片素材'))
  }

  if (!model) return callback(new Error('请选择品牌图片'))

  if (model.size > image_restriction.file_size * 1024) {
    return callback(new Error('图片大小不能超过' + image_restriction.file_size + 'KB'))
  }

  if (model.width !== image_restriction.width) {
    return callback(new Error('图片宽度必须为' + image_restriction.width + 'px'))
  }

  if (model.height !== image_restriction.height) {
    return callback(new Error('图片高度必须为' + image_restriction.height + 'px'))
  }

  callback()
}

/**
 * @description: 品牌名称校验
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 * @return {*}
 */
function brandNameValidator(rule, value, callback) {
  const { restriction } = this
  const { text_restriction } = restriction
  const model = value.brand_name

  if (!model) {
    return callback(new Error('请输入品牌名称'))
  }

  if (!new RegExp(text_restriction.text_pattern).test(model)) {
    return callback(new Error('品牌名称格式不正确'))
  }
  if (valueLength(model) > text_restriction.max_length) {
    return callback(new Error('品牌名称不能超过' + text_restriction.max_length + '个字'))
  }

  if (valueLength(model) < text_restriction.min_length) {
    return callback(new Error('品牌名称不能少于' + text_restriction.min_length + '个字'))
  }

  callback()
}

function buttonTextValidator(rule, value, callback) {
  const model = value

  if (!model) {
    return callback(new Error('请选择按钮文字'))
  }
  callback()
}

function descriptionOptionsValidator(rule, value, callback) {
  const model = value
  const { restriction } = this
  const { text_restriction } = restriction

  try {
    model.forEach((m, index) => {
      const msg = `文案行${index + 1}：`
      if (!m.text.trim()) {
        throw new Error(`${msg}不能为空`)
      }

      if (!new RegExp(text_restriction.text_pattern).test(m.text)) {
        throw new Error(`${msg}格式不正确`)
      }

      if (valueLength(m.text) > text_restriction.max_length) {
        throw new Error(`${msg}不能超过${text_restriction.max_length}个字`)
      }

      if (valueLength(m.text) < text_restriction.min_length) {
        throw new Error(`${msg}不能少于${text_restriction.min_length}个字`)
      }
    })

    callback()
  } catch (e) {
    callback(e)
  }
}

function titleOptionsValidator(rule, value, callback) {
  const model = value
  const { restriction } = this
  const { text_restriction } = restriction
  try {
    model.forEach((m, index) => {
      const msg = `文案行${index + 1}：`
      if (!m.text.trim()) {
        throw new Error(`${msg}不能为空`)
      }
      if (!new RegExp(text_restriction.text_pattern).test(m.text)) {
        throw new Error(`${msg}格式不正确`)
      }

      if (valueLength(m.text) > text_restriction.max_length) {
        throw new Error(`${msg}不能超过${text_restriction.max_length}个字`)
      }

      if (valueLength(m.text) < text_restriction.min_length) {
        throw new Error(`${msg}不能少于${text_restriction.min_length}个字`)
      }
    })

    callback()
  } catch (e) {
    callback(e)
  }
}

function endPageTypeValidator(rule, value, callback) {
  const model = value.end_page_type
  if (!model) {
    return callback(new Error('请选择结束页类型'))
  }
  callback()
}

function endPageDescValidator(rule, value, callback) {
  const { restriction } = this
  const { text_restriction } = restriction
  const model = value.end_page_desc
  if (!model) {
    return callback(new Error('请输入结束页描述'))
  }

  if (!new RegExp(text_restriction.text_pattern).test(model)) {
    return callback(new Error('结束页文案格式不正确'))
  }

  if (valueLength(model) > text_restriction.max_length) {
    return callback(new Error('结束页文案不能超过' + text_restriction.max_length + '个字'))
  }

  if (valueLength(model) < text_restriction.min_length) {
    return callback(new Error('结束页文案不能少于' + text_restriction.min_length + '个字'))
  }

  callback()
}

function wechatChannelValidator(rule, value, callback) {
  const model = value
  if (!model.username) {
    return callback(new Error('请选择视频号'))
  }

  callback()
}

function floatingZoneType(rule, value, callback) {
  if (!value.type) {
    return callback(new Error('请选择浮层卡片类型'))
  }
  callback()
}

function floatingZoneImage(rule, value, callback) {
  if (!value.image_id) {
    return callback(new Error('请选择创意图片'))
  }
  callback()
}

function floatingZoneButtonText(rule, value, callback) {
  if (!value.button_text) {
    return callback(new Error('请选择按钮文字'))
  }
  callback()
}

function floatingZoneDesc(rule, value, callback) {
  const { restriction } = this
  const { text_restriction } = restriction
  const model = value
  if (!model.desc) {
    return callback(new Error('请输入文案'))
  }

  if (!new RegExp(text_restriction.text_pattern).test(model.desc)) {
    return callback(new Error('文案格式不正确'))
  }

  if (valueLength(model.desc) > text_restriction.max_length) {
    return callback(new Error('文案不能超过' + text_restriction.max_length + '个字'))
  }

  if (valueLength(model.desc) < text_restriction.min_length) {
    return callback(new Error('文案不能少于' + text_restriction.min_length + '个字'))
  }

  callback()
}

function floatingZoneName(rule, value, callback) {
  const { restriction } = this
  const { text_restriction } = restriction
  const model = value

  if (!model.name) {
    return callback(new Error('请输入文案'))
  }

  if (!new RegExp(text_restriction.text_pattern).test(model.name)) {
    return callback(new Error('文案格式不正确'))
  }

  if (valueLength(model.name) > text_restriction.max_length) {
    return callback(new Error('文案不能超过' + text_restriction.max_length + '个字'))
  }

  if (valueLength(model.name) < text_restriction.min_length) {
    return callback(new Error('文案不能少于' + text_restriction.min_length + '个字'))
  }

  callback()
}

function videoOptionsValidator(rule, value, callback) {
  const model = value
  const { restriction } = this
  const { video_restriction, image_restriction } = restriction
  if (!model.length) {
    return callback(new Error('请选择视频素材'))
  }
  if (model.length > 30) {
    return callback(new Error('视频素材不能超过30个'))
  }

  try {
    model.forEach((video, index) => {
      const msg = `视频素材${index + 1}：`
      const { size, height, width } = video
      if (size > video_restriction.file_size * 1024) {
        throw new Error(`${msg}大小不能超过${video_restriction.file_size}KB`)
      }
      if (height !== video_restriction.min_height) {
        throw new Error(`${msg}高度必须为${video_restriction.min_height}px`)
      }
      if (width !== video_restriction.min_width) {
        throw new Error(`${msg}宽度必须为${video_restriction.min_width}px`)
      }
    })

    // 视频封面校验
    // 朋友圈、公众号版位没有image_restriction，不用校验视频封面
    if (image_restriction) {
      const imageModel = model.map((video) => ({ width: video.cover_width, size: video.cover_size, height: video.cover_height }))
      imageValidator(imageModel, image_restriction)
    }

    callback()
  } catch (e) {
    callback(e)
  }
}

function elementStoryValidator(rule, value, callback) {
  const model = value
  const { restriction } = this
  const { image_restriction } = restriction

  const images = model.image.filter((img) => img.id)
  if (images?.length !== 3) {
    return callback(new Error('请选择3张图片素材'))
  }

  try {
    imageValidator(images, image_restriction)

    callback()
  } catch (e) {
    callback(e)
  }
}

// 同时验证图片素材，三小图，及视频封面素材
function imageValidator(model, image_restriction) {
  model.forEach((img, index) => {
    const msg = `图片素材${index + 1}：`
    const { size, height, width } = img
    if (size > image_restriction.file_size * 1024) {
      throw new Error(`${msg}大小不能超过${image_restriction.file_size}KB`)
    }
    if (height !== image_restriction.height) {
      throw new Error(`${msg}高度必须为${image_restriction.height}px`)
    }
    if (width !== image_restriction.width) {
      throw new Error(`${msg}宽度必须为${image_restriction.width}px`)
    }
  })
}

function imageOptionsValidator(rule, value, callback) {
  const model = value
  const { restriction } = this
  const { image_restriction } = restriction
  if (!model.length) {
    return callback(new Error('请选择图片素材'))
  }
  if (model.length > 30) {
    return callback(new Error('图片素材不能超过30个'))
  }

  try {
    imageValidator(model, image_restriction)

    callback()
  } catch (e) {
    callback(e)
  }
}

function pageInfoValidator(rule, value, callback) {
  for (const i in value) {
    const page = value[i].page
    if (!page.page_id) {
      return callback(new Error('请选择落地页'))
    }
  }

  callback()
}

/**
 * @description: 腾讯广告v3创意表单验证规则
 */
export function creativeFormV3Rules() {
  return {
    ...creativeFormRules,
    dynamic_creative_name: creativeFormRules.name,
    selectedAssets: [
      {
        validator: (rule, value, callback) => {
          if (Object.values(value).flat().length === 0) {
            return callback(new Error('请选择素材'))
          }

          // 单选朋友圈版位时，视频素材只能选择5-30秒内的长度范围
          const { siteSet } = this.planForm
          const isMoment = siteSet.length === 1 && siteSet.includes(SITE_ENUM.MOMENTS)
          if (isMoment && value.video?.length) {
            for (const i in value.video) {
              const { duration } = value.video[i]
              if (duration < 5 || duration > 30) {
                return callback(new Error(`【视频${Number(i) + 1}】长度范围须在5～30秒`))
              }
            }
          }

          if (value.image?.length) {
            // 图片素材不能大于400k
            for (const i in value.image) {
              const { size } = value.image[i]

              if (size > 400 * 1024) {
                return callback(new Error(`图片${Number(i) + 1}大小须小于400k`))
              }
            }
          }

          callback()
        },
        trigger: 'change',
        required: true
      }
    ],
    description: [
      {
        validator: (rule, value, callback) => {
          for (const i in value) {
            const content = value[i].content.trim()
            if (!content) {
              return callback(new Error(`行${Number(i) + 1}请输入文案`))
            }
          }
          callback()
        },
        trigger: 'blur',
        required: true
      }
    ],
    pageInfo: [
      {
        validator: pageInfoValidator,
        trigger: 'blur'
      }
    ],
    'components.brand': [
      {
        validator: (rule, value, callback) => {
          const { brandType, brandInfo, profileInfo, officialAccountInfo } = value
          if (!brandType) return callback(new Error('品牌形象跳转'))
          if (brandType === BRAND_ENUM.CHANNEL) {
            const { channelInfo } = this.group.components.wechat_channels || {}
            if (!channelInfo?.promoted_object_id) return callback(new Error('请选择视频号'))
          }

          if (brandType === BRAND_ENUM.OFFICIAL_ACCOUNT) {
            if (!officialAccountInfo?.promoted_object_id) return callback(new Error('请选择公众号'))
          }
          if (brandType === BRAND_ENUM.PROFILE) {
            if (!profileInfo || !profileInfo.profile_id) return callback(new Error('请选择品牌简介页'))
            if (profileInfo.profile_name.length >= 12) return callback(new Error('名称过长超过12个字，请选择其他品牌名称或者新建'))
          }

          if (brandType === BRAND_ENUM.BRAND) {
            if (!brandInfo || !brandInfo.image_id) return callback(new Error('请选择品牌形象'))
          }

          callback()
        },
        trigger: 'change',
        required: true
      }
    ],
    'components.text_link': [
      {
        validator: (rule, value, callback) => {
          const { value: v, switch: isOpen, page_type } = value
          if (isOpen) {
            if (!v) return callback(new Error('请选择文字链文案'))
            if (!page_type) return callback(new Error('请选择跳转落地页类型'))
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    'components.action_button': [
      {
        validator: (rule, value, callback) => {
          const { value: v, switch: isOpen } = value
          if (isOpen) {
            if (!v) return callback(new Error('请选择按钮文案'))
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    'components.app_gift_pack_code': [
      {
        validator: (rule, value, callback) => {
          const { description, code, switch: isOpen } = value
          if (isOpen) {
            if (!description) return callback(new Error('请输入礼包描述'))
            if (!code) return callback(new Error('请输入礼包码'))
          }
          callback()
        },
        trigger: 'blur'
      }
    ],
    'components.mini_card_link': [
      {
        validator: (rule, value, callback) => {
          const { mini_card_link_description, switch: mini_card_link_switch, mini_card_link_image, page_type } = value
          if (mini_card_link_switch) {
            const descTextCounts = valueLength(mini_card_link_description)

            if (mini_card_link_image.size > 1024 * 400) {
              return callback(new Error('图片大小不能超过400KB'))
            }
            if (!descTextCounts) return callback(new Error('请输入文案'))
            if (descTextCounts > 8) return callback(new Error('2个英文占1个字，文案不能超过8个字'))
            if (!page_type) return callback(new Error('请选择跳转落地页类型'))
          }
          callback()
        },
        trigger: ['blur', 'change']
      }
    ],
    'components.floating_zone': [
      {
        validator: (rule, value, callback) => {
          const { siteSet } = this.planForm || {}
          const isChannels = siteSet && siteSet.length === 1 && siteSet.includes(SITE_ENUM.CHANNELS)
          const { floating_zone_desc, floating_zone_name, floating_zone_switch, floating_zone_image, floating_zone_button_text } = value

          if (isChannels && !floating_zone_switch) return callback(new Error('请开启浮层卡片'))
          if (floating_zone_switch) {
            if (!floating_zone_image?.id) return callback(new Error('请选择图片'))
            if (floating_zone_image.size > 1024 * 400) {
              return callback(new Error('图片大小不能超过400KB'))
            }
            if (!floating_zone_name) return callback(new Error('请输入文案一'))
            if (!floating_zone_desc) return callback(new Error('请输入文案二'))
            if (floating_zone_name && floating_zone_name.length > 10) return callback(new Error('文案一不能超过10个字'))
            if (floating_zone_desc && floating_zone_desc.length > 14) return callback(new Error('文案二不能超过14个字'))
            if (!floating_zone_button_text) return callback(new Error('请选择按钮文案'))
          }
          callback()
        },
        trigger: ['blur', 'change']
      }
    ],
    'components.end_page': [
      {
        validator: (rule, value, callback) => {
          const { end_page_desc, switch: isOpen } = value
          if (isOpen) {
            if (!end_page_desc) return callback(new Error('请输入结束页文案'))
          }
          callback()
        },
        trigger: 'blur'
      }
    ],

    'components.social_skill': [
      {
        validator: (rule, value, callback) => {
          const { social_skill_first_comment, social_skill_first_comment_switch } = value
          if (social_skill_first_comment_switch) {
            if (!social_skill_first_comment?.trim()) return callback(new Error('请输入首评回复内容或关闭首评回复开关'))
          }
          callback()
        },
        trigger: ['blur', 'change']
      }
    ],
    'components.barrage': [
      {
        validator: (rule, value, callback) => {
          if (value?.length && value.length < 3) return callback(new Error('至少选择3条弹幕'))
          callback()
        },
        trigger: 'blur'
      }
    ],
    'components.show_data': [
      {
        validator: (rule, value, callback) => {
          const { switch: show_data_switch, conversion_data_type, conversion_target_type } = value
          if (show_data_switch) {
            if (conversion_data_type === 'CONVERSION_DATA_ADMETRIC') {
              if (!conversion_target_type) return callback(new Error('请选择数据外显转化目标'))
              const { ch_platform_id } = this.planForm
              const isMiniGame = ch_platform_id === PLATFORM.MINIGAME
              if (isMiniGame) {
                if (MINIGAME_CONVERSION_TARGET_LIST.every((target) => target.value !== conversion_target_type)) {
                  return callback(new Error('请选择数据外显转化目标'))
                }
              } else {
                if (APP_CONVERSION_TARGET_LIST.every((target) => target.value !== conversion_target_type)) {
                  return callback(new Error('请选择数据外显转化目标'))
                }
              }
            }
          }

          callback()
        }
      }
    ],
    // 组件化创意自动匹配试玩营销组件
    'components.wxgame_playable_component': [
      {
        validator: (rule, value, callback) => {
          const {
            switch: wxgame_playable_switch,
            end_cover_img,
            card_link_image,
            wxgame_playable_page_end_desc,
            wxgame_playable_page_path,
            wxgame_playable_page_trigger_text,
            wxgame_playable_page_card_link_description
          } = value
          const { url: coverUrl, width, height, size } = card_link_image
          const { url: endCoverUrl, width: endCoverWidth, height: endCoverHeight, size: endCoverSize } = end_cover_img
          if (wxgame_playable_switch) {
            if (!coverUrl) {
              return callback(new Error('请选择试玩图片'))
            }
            if (!endCoverUrl) {
              return callback(new Error('请选择试玩结束页图片'))
            }
            if (`${width}*${height}` !== '800*800') {
              return callback(new Error('图片尺寸必须为800*800'))
            }
            if (`${endCoverWidth}*${endCoverHeight}` !== '1280*720') {
              return callback(new Error('结束页图片尺寸必须为1280*720'))
            }

            // 不能大于400kb
            if (size > 400 * 1024) {
              return callback(new Error('图片不能大于400kb'))
            }
            if (endCoverSize > 400 * 1024) {
              return callback(new Error('结束页图片不能大于400kb'))
            }

            if (!wxgame_playable_page_path) {
              return callback(new Error('请选择试玩页链接'))
            }

            if (!wxgame_playable_page_card_link_description) {
              return callback(new Error('请输入试玩文案'))
            }
            if (!wxgame_playable_page_trigger_text) {
              return callback(new Error('请选择试玩按钮文案'))
            }
            if (!wxgame_playable_page_end_desc) {
              return callback(new Error('请输入试玩结束页文案'))
            }
            if (Math.ceil(getByteLen(wxgame_playable_page_card_link_description)) > 16) {
              return callback(new Error('试玩文案不能超过16个字符'))
            }
            if (Math.ceil(getByteLen(wxgame_playable_page_end_desc)) > 16) {
              return callback(new Error('试玩结束页文案不能超过16个字符'))
            }
          }
          callback()
        }
      }
    ],
    // 只会在批量复制和批量修改时校验
    'components.wxgame_playable': [
      {
        validator: (rule, value, callback) => {
          const { wxgame_playable_page_path } = this.group.components?.wxgame_playable_page || {}
          if (!wxgame_playable_page_path) {
            return callback(new Error('请选择试玩结束页'))
          }

          callback()
        }
      }
    ],
    // 只有批量新建时需要校验
    'components.wxgame_playable_material_config': [
      {
        validator: (rule, value, callback) => {
          const { playable_page_path } = value
          if (!playable_page_path) {
            return callback(new Error('请选择试玩页'))
          }
          callback()
        }
      }
    ],
    // 自定义创意手动匹配小游戏试玩，批量新建时不校验，批量复制、批量修改、单条修改需要校验
    'components.wxgame_playable_page': [
      {
        validator: (rule, value, callback) => {
          const { wxgame_playable_page_switch, wxgame_playable_page_end_cover_img, wxgame_playable_page_end_desc } = value
          const { url: coverUrl, width, height } = wxgame_playable_page_end_cover_img
          if (wxgame_playable_page_switch) {
            if (!coverUrl) {
              return callback(new Error('请选择试玩结束页图片'))
            }
            if (`${width}*${height}` !== '1280*720') {
              return callback(new Error('图片尺寸必须为1280*720'))
            }
            if (!wxgame_playable_page_end_desc) {
              return callback(new Error('请输入试玩结束页文案'))
            }
            if (Math.ceil(getByteLen(wxgame_playable_page_end_desc)) > 20) {
              return callback(new Error('试玩结束页文案不能超过20个字符'))
            }
          }
          callback()
        }
      }
    ]
  }
}
